import React from "react";
import PropTypes from "prop-types";
import { injectIntl, intlShape, FormattedMessage } from "react-intl";
import { DropdownButton, MenuItem } from "react-bootstrap";
import * as Table from "reactabular-table";
import { formatDate, formatValue, formatValueUnit } from "./GrafikenCommon"
import _ from "lodash";
import ButtonSetDateAndTime from "./ButtonSetDateAndTime";

import "./DatenTabellen.css"

const renderYValue = (y_value, key, change_fct) => (
	<MenuItem key={key} onClick={ () => { change_fct(y_value.index); }}>
		<FormattedMessage id={y_value.i18n_key} />
	</MenuItem>
);

const getYComponent = (y_components, y_component_index) => {
	let y_component = null;
	y_components.forEach(component => {
		if (component.index === y_component_index) {
			y_component = component;
		}
	});
	return y_component;
};

const makeYChosenComponent = (y_components, y_component_index, intl) => {
	let y_component = getYComponent(y_components, y_component_index);
	return y_component && y_component.makeLabel(intl);
};

const renderYComponent = (y_component, key, change_fct, intl) => (
	<MenuItem key={key} onClick={ () => { change_fct(y_component.index); }}>
		{ y_component.makeLabel(intl) }
	</MenuItem>
);

const getRows = (log_values, y_value, units, intl) => {
	let counter = 1;
	let rows = [];
	let lastTimestamp = -1;
	for(let i = 0; i < log_values.length; ++i) {
		const log_value = log_values[i];
		const currentTimestamp = log_value.date;
		const value = _.at(log_value, y_value.path);
		if(lastTimestamp !== currentTimestamp) {
			const time = formatDate(log_value.date, intl);
			const data = formatValue(value, y_value, units, intl);
			const key = counter;
			rows.push({key, time, data});
			counter++;
		}
		lastTimestamp = currentTimestamp;
	}
	return rows;
}

const DatenTabellen = props => {

	const {
		x_range, 
		x_range_valid,
		y_values,
		y_value,
		y_components,
		y_component_index,
		changeYValue,
		changeYComponent,
		log_values,
		units,
		setNewRangeX,
		dataSourceOfCharts,
		setDataSourceOfCharts,
		intl
	} = props;

	return (
		<div className="Datatable printableAlmigItem">
			<div id="ButtonsYValueAndComponent">
				<DropdownButton id="DropDownButtonYValue"
					className="DropdownButtonYValueAndComponent"
					title={intl.formatMessage({ id: y_value.i18n_key})}>
					{ y_values.map((y_value, i) => (
						renderYValue(y_value, i, changeYValue)
					))}
				</DropdownButton>
				<DropdownButton id="DropDownButtonYComponent"
					className="DropdownButtonYValueAndComponent"
					title={makeYChosenComponent(y_components,
						y_component_index, intl)}>
					{ y_components.map((y_component, i) => (
						renderYComponent(y_component, i, changeYComponent, intl)
					))}
				</DropdownButton>
			</div>
			<div id="ButtonsVonBis">
				<div id="LabelShowFrom">
					{intl.formatMessage({ id: "From" })}
				</div>
				<div id="ButtonShowForm">
					<ButtonSetDateAndTime
						validRange={[x_range_valid[0], x_range[1] - 1000]}
						currentDateTimeMs={x_range[0]}
						acceptNewDate={newDate => { setNewRangeX([newDate, x_range[1]]); }}
						popupPlacement="right"
						dataSourceOfCharts={dataSourceOfCharts}
						setDataSourceOfCharts={setDataSourceOfCharts}
					/>
				</div>
				<div id="LabelShowUntil">
					{intl.formatMessage({ id: "Until" })}
				</div>
				<div id="ButtonShowUntil">
					<ButtonSetDateAndTime
						validRange={[x_range[0] + 1000, x_range_valid[1]]}
						currentDateTimeMs={x_range[1]}
						acceptNewDate={newDate => { setNewRangeX([x_range[0], newDate]); }}
						popupPlacement="right"
						dataSourceOfCharts={dataSourceOfCharts}
						setDataSourceOfCharts={setDataSourceOfCharts}
					/>
				</div>
				
			</div>
			<div>
				<Table.Provider
					columns={[
						{
							property: "key",
							header: {
								label: "#"
							}
						},
						{
							property: "time",
							header: {
								label: intl.formatMessage({ id: "Time" })
							}
						},
						{
							property: "data",
							header: {
								label: intl.formatMessage({ id: y_value.i18n_key}) + " [" + formatValueUnit(y_value, units, intl) + "]"
							}
						}
					]}
				>
					<Table.Header />
					<Table.Body rows={getRows(log_values, y_value, units, intl)} rowKey="key"/>
				</Table.Provider>
			</div>
		</div>
	);
};

DatenTabellen.propTypes = {
	y_values: PropTypes.arrayOf(PropTypes.object).isRequired,
	y_value: PropTypes.object.isRequired,
	y_components: PropTypes.arrayOf(PropTypes.object).isRequired,
	y_component_index: PropTypes.number.isRequired,
	changeYValue: PropTypes.func.isRequired,
	changeYComponent: PropTypes.func.isRequired,
	log_values: PropTypes.arrayOf(PropTypes.object).isRequired,
	units: PropTypes.object.isRequired,
	setNewRangeX: PropTypes.func.isRequired,
	dataSourceOfCharts: PropTypes.number.isRequired,
	setDataSourceOfCharts: PropTypes.func.isRequired,
	intl: intlShape.isRequired
};

export default injectIntl(DatenTabellen);